// extracted by mini-css-extract-plugin
export default {"container":"cannotDelete_container__GSWOy","title":"cannotDelete_title__ZTq3L","buttonsContainer":"cannotDelete_buttonsContainer__Q8y1f"};